// extracted by mini-css-extract-plugin
module.exports = {"submitBtn":"submitBtn--2efbj"};